import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

const ModalPopup = ({
  title,
  children,
  onClose,
  size = "lg",
  noHeader = false,
  noBorder = false,
  className = "",
  zIndex = "z-[99999999]",
  bodyStyleObject = {},
}) => {
  const sizeMap = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
    "2xl": "max-w-2xl",
    full: "w-full h-full",
  };

  const [show, setShow] = useState(false);

  useEffect(() => {
    setTimeout(() => setShow(true), 100);
  }, []);

  const modalClasses = `bg-white rounded-2xl shadow-lg w-full transform transition-all duration-300 ease-out overflow-y-auto
    ${sizeMap[size] || sizeMap["lg"]} ${show ? 'opacity-100 scale-100' : 'opacity-0 scale-95'} ${className}`;

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center bg-[#0000008f] bg-opacity-50 transition-opacity duration-300 ${zIndex}`}
    >
      <div className={modalClasses}>
        {/* Close Button */}
        {onClose && (
          <div className="flex justify-end p-2">
            <button
              onClick={onClose}
              className="text-gray-300 hover:text-gray-500 p-1"
            >
              <CloseIcon style={{ fontSize: 20 }} />
            </button>
          </div>
        )}

        {/* Header */}
        {!noHeader && (
          <div
            className={`text-lg font-semibold px-6 py-3 ${
              noBorder ? "" : "border-b border-gray-200"
            }`}
          >
            {title}
          </div>
        )}

        {/* Body */}
        <div className="px-6 py-4" style={bodyStyleObject}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default ModalPopup;
